var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63636 18.0022H5.45456V8.72949L2.95434 4.36365L0 4.63857V16.3659C0 17.2699 0.732281 18.0022 1.63636 18.0022Z",
    fill: "#0085F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5454 18.0022H22.3636C23.2677 18.0022 24 17.2699 24 16.3659V4.63857L21.0499 4.36365L18.5455 8.72949V18.0022H18.5454Z",
    fill: "#00A94B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5456 1.63856L16.3027 5.91839L18.5456 8.72948L24.0001 4.63856V2.45676C24.0001 0.434483 21.6915 -0.720517 20.0728 0.493124L18.5456 1.63856Z",
    fill: "#FFBC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45455 8.72947L3.31738 4.21494L5.45455 1.63855L12 6.54763L18.5454 1.63855V8.72947L12 13.6385L5.45455 8.72947Z",
    fill: "#FF4131"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.45676V4.63856L5.45456 8.72948V1.63856L3.92728 0.493124C2.30864 -0.720517 0 0.434483 0 2.45676Z",
    fill: "#E51C19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.71074899f4d1491c0d08ee97fe887d5b.svg";
export { ForwardRef as ReactComponent };